import { useEffect, useRef } from 'react';
import { readAuthReturnPath, rememberAuthReturnPath, safeAuthReturnPath } from '../utils/authReturnPath';

/** Keep the explicit destination stable across Clerk's nested authentication steps. */
export default function useAuthReturnPath(nextParam, isSignedIn, clerkRedirectParam) {
  const returnPathRef = useRef(undefined);
  if (returnPathRef.current === undefined) {
    returnPathRef.current = readAuthReturnPath();
  }
  const explicitPath = safeAuthReturnPath(nextParam);
  if (explicitPath) returnPathRef.current = explicitPath;
  if (!returnPathRef.current) returnPathRef.current = safeAuthReturnPath(clerkRedirectParam);

  const afterAuthUrl = returnPathRef.current || '/';
  useEffect(() => {
    if (isSignedIn || !returnPathRef.current) return;
    rememberAuthReturnPath(afterAuthUrl);
  }, [afterAuthUrl, isSignedIn]);

  return {
    afterAuthUrl,
    // An explicit app destination wins over Clerk's redirect_url/defaults.
    forceRedirectUrl: returnPathRef.current || undefined,
  };
}
